module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-gebaeudehuelle-ffc0900502dbddb2e64fd6d13588ff23.svg";